// PhotoSwipe for galleries
import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';
import 'photoswipe/dist/photoswipe.css';

function isPhonePortrait() {
    return window.matchMedia('(max-width: 600px) and (orientation: portrait)').matches;
}

// Our games Product gallery - desktop
const lightboxProductGallery = new PhotoSwipeLightbox({
    gallery              : '#our-games-product-gallery-carousel',
    children             : 'a',
    showHideAnimationType: 'fade',
    pswpModule           : PhotoSwipe
});
lightboxProductGallery.init();

// Our games Product gallery - mobile
const lightboxProductGalleryMobile = new PhotoSwipeLightbox({
    gallery              : '#mobile-our-games-product-gallery',
    children             : 'a',
    showHideAnimationType: 'fade',

    initialZoomLevel  : (zoomLevelObject) => {
        return zoomLevelObject.fit;
    },
    secondaryZoomLevel: (zoomLevelObject) => {
        return 1;
    },

    maxZoomLevel: 1,

    pswpModule: PhotoSwipe
});
lightboxProductGalleryMobile.init();


// Our games Art gallery - desktop
const lightboxArtGallery = new PhotoSwipeLightbox({
    gallery              : '#our-games-photo-gallery-carousel.swiper',
    children             : 'a',
    showHideAnimationType: 'fade',
    pswpModule           : PhotoSwipe
});
lightboxArtGallery.init();

// Our games Art gallery - mobile
const lightboxArtGalleryMobile = new PhotoSwipeLightbox({
    gallery              : '#mobile-our-games-photo-gallery.swiper',
    children             : 'a',
    showHideAnimationType: 'fade',

    initialZoomLevel  : (zoomLevelObject) => {
        return zoomLevelObject.fit;
    },
    secondaryZoomLevel: (zoomLevelObject) => {
        return 1;
    },

    maxZoomLevel: 1,

    pswpModule: PhotoSwipe
});
lightboxArtGalleryMobile.init();

